module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_4-3e53d42cdf25ed1e3416c5c41456e08a.svg";